import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { onAuthStateChanged, User } from 'firebase/auth';
import { auth } from '../firebase';
import { LoadingScreen } from './shared/Loading';

const RootRedirect: React.FC = () => {
    const [user, setUser] = useState<User | null>(null);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            setUser(user);
            setLoading(false);
        });
        return () => unsubscribe();
    }, []);

    if (loading) {
        return <LoadingScreen />;
    }

    if (user) {
        return <Navigate to="/tasks" />;
    }

    // Unauthenticated users on app.pocket.garden go to login
    return <Navigate to="/login" />;
};

export default RootRedirect;
